import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { ApiService } from '../api/api.service';
export const authGuard: CanActivateFn = async (route, state) => {
  const api = inject(ApiService);
  const router = inject(Router);
  var infos = await api.get_from_local_storage("infos")
  // console.log("infos = ", infos);
  if (infos != undefined && infos != null) {
    console.log("Utilisateur connecté")
    await api.update_infos()
    return true
  } else {
    console.log("Utilisateur non connecté")
    router.navigate(['/public/login'], { queryParams: { returnUrl: state.url } });
    return false
  }
};